// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"styles_linksWrapper__2A4XR","link":"styles_link___Zs8D"};